export default __webpack_public_path__ + "static/media/RightArrow.bb651d27.svg";